import { INewbuildingCardMapConfig } from '../../types/map';
import { DEFAULT_DINAMIC_MAP_URL } from '@cian/frontend-newbuilding-map-component';

export const GEO_OBJECT_NAMES = [
  'finished',
  'inProgress',
  'inProject',
  'main',
  'partialFinish',
  'point',
  'specialPromo',
];

export const DEFAULT_MAP_CONFIG: INewbuildingCardMapConfig = {
  /**
   * Начальный зум карты.
   */
  defaultZoom: 15,
  /**
   * Скорость анимации при пермещении карты
   */
  animationDuration: 300,
  /**
   * Специальная задержка для оптимизации отрисовки пинов
   */
  geoObjectsLoadDelay: 300,
  /**
   * Кол-во отрисовывающихся одновременно пинов
   */
  maxGeoObjectsPerLoad: 50,
  /**
   * Максимальный зум карты.
   */
  zoomRangeMax: 17,
  /**
   * Минимальный зум карты.
   */
  zoomRangeMin: 14,
  /**
   * Список отображающихся контролов.
   */
  controls: ['ZoomControl', 'GeolocationControl', 'RulerControl'],
  /**
   * Список типов отображающихся геообъектов.
   */
  geoObjectNames: GEO_OBJECT_NAMES,
  /**
   * Кластаризация.
   */
  clusterize: false,
  /**
   * Размер кластера в пикселях.
   */
  clusterGridSize: 0,
  /**
   * Адрес Yandex Map API.
   */
  apiUrl: DEFAULT_DINAMIC_MAP_URL,
};
